import { Box } from "@mui/material";
import { DotLegalHeader, DotLegalPdfBackPage } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "@localization/useTranslation";
import PdfReportFrontPage from "@common/PdfReportFrontPage";
import { useSetPdfPageSize } from "../../../common/pdfPageSizeHelper";
import RiskReportKpiCards from "../RiskReportKpiCards";
import RiskReportCharts from "../RiskReportCharts";
import { useRiskManagementReport } from "../RiskManagementReport.hooks";
import useRiskManagementReportPdfHooks from "./RiskManagementReportPdf.hooks";

function RiskManagementReportPdf() {
    const { translateString } = useTranslation();
    const { note } = useRiskManagementReportPdfHooks();
    const { isLoading, riskAppetiteLimit, risksAboveAppetite, isExceeded, coverage, risksOverAppetiteByArea, countAboveAppetite, exposureCards } =
        useRiskManagementReport();
    useSetPdfPageSize("portrait");

    if (isLoading) {
        return null;
    }

    return (
        <Box>
            <PdfReportFrontPage title={translateString("riskManagementReport")} orientation="portrait" />
            {/* Puppeteer rasterises DotLegalPaper's #E7E7E7 shadow as a flat grey block filling the panel padding instead of a
                blur, and drops it for some papers, so the report reads as "grey behind some cards but not others". The cards sit
                on the lavender report panel, so they keep a clear edge without any shadow. */}
            <Box ml={2} mr={2} sx={{ "& .MuiPaper-root": { boxShadow: "none" } }}>
                {note && (
                    <Box sx={{ whiteSpace: "pre-wrap", mb: 2, pt: 2 }}>
                        <DotLegalHeader fontWeight={400} fontStyle="italic" headerStyle={"large"}>
                            {translateString("note")}: {note}
                        </DotLegalHeader>
                    </Box>
                )}

                <RiskReportKpiCards
                    stacked
                    riskAppetiteLimit={riskAppetiteLimit}
                    risksAboveAppetite={risksAboveAppetite}
                    isExceeded={isExceeded}
                    coverage={coverage}
                    exposureCards={exposureCards}
                />

                <RiskReportCharts
                    stacked
                    risksOverAppetiteByArea={risksOverAppetiteByArea}
                    countAboveAppetite={countAboveAppetite}
                    appetiteLimit={riskAppetiteLimit}
                />
            </Box>
            {/* The back page has a fixed 793px (~210mm/landscape) height with its footer pinned to its own
                bottom, so on a taller portrait page it stops short. Stretch its root to the full page height. */}
            <Box className="page-break-before" sx={{ "& > div": { height: "297mm" } }}>
                <DotLegalPdfBackPage />
            </Box>
        </Box>
    );
}

export default RiskManagementReportPdf;
